import { render, staticRenderFns } from "./IconThumbDownSolid.vue?vue&type=template&id=0af76b95"
import script from "./IconThumbDownSolid.vue?vue&type=script&lang=js"
export * from "./IconThumbDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports